<template>
    <div class="vx-row">
        <div class="vx-col w-full lg:w-2/3">
            <vs-card>
                <div slot="header">Créer un utilisateur</div>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-input style="width: 10px"
                                          label="Nom"
                                          v-model="input.lastname"
                                          class="w-full"
                                          name="title"
                                          :danger="!!formErrors.lastname"
                                          :danger-text="formErrors.lastname ? formErrors.lastname[0] : ''"
                                          v-on:input="resetErrors('lastname')"
                                />
                            </div>
                            <div class="w-1/2 px-2">
                                <vs-input
                                        label="Prénoms"
                                        v-model="input.firstname"
                                        class="w-full"
                                        name="title"
                                        :danger="!!formErrors.firstname"
                                        :danger-text="formErrors.firstname ? formErrors.firstname[0] : ''"
                                        v-on:input="resetErrors('firstname')"
                                />
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Equipe"
                                        v-model="input.team"
                                        placeholder="Sélectionner une équipe"
                                        :danger="!!formErrors.team"
                                        :danger-text="formErrors.team ? formErrors.team[0] : ''"
                                        v-on:change="resetErrors('team')"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in teams"
                                    />
                                </vs-select>
                            </div>
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Fonction"
                                        v-model="input.fonction"
                                        placeholder="Sélectionner une fonction"
                                        :danger="!!formErrors.fonction"
                                        :danger-text="formErrors.fonction ? formErrors.fonction[0] : ''"
                                        v-on:change="resetErrors('fonction')"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in functions"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-input
                                        label="Username"
                                        @keyup.enter="submitData"
                                        v-model="input.username"
                                        class="w-full"
                                        name="username"
                                        :danger="!!formErrors.username"
                                        :danger-text="formErrors.username ? formErrors.username[0] : ''"
                                        v-on:input="resetErrors('username')"
                                />
                            </div>
                            <div class="w-1/2 px-2">
                                <vs-input
                                        label="Email"
                                        @keyup.enter="submitData"
                                        v-model="input.email"
                                        class="w-full"
                                        name="email"
                                        :danger="!!formErrors.email"
                                        :danger-text="formErrors.email ? formErrors.email[0] : ''"
                                        v-on:input="resetErrors('email')"
                                />
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-input
                                        type="number"
                                        label="Numéro de téléphone"
                                        @keyup.enter="submitData"
                                        v-model="input.phone"
                                        class="w-full"
                                        name="phone"
                                        :danger="!!formErrors.phone"
                                        :danger-text="formErrors.phone ? formErrors.phone[0] : ''"
                                        v-on:input="resetErrors('phone')"
                                />
                            </div>
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Age"
                                        v-model="input.birthday"
                                        placeholder="Sélectionner l'âge"
                                        :danger="!!formErrors.birthday"
                                        :danger-text="formErrors.birthday ? formErrors.birthday[0] : ''"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item"
                                            :text="item"
                                            v-for="(item,index) in periods"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Ancienneté"
                                        v-model="input.hired_at"
                                        placeholder="Sélectionner l'ancienneté"
                                        :danger="!!formErrors.hired_at"
                                        :danger-text="formErrors.hired_at ? formErrors.hired_at[0] : ''"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item"
                                            :text="item"
                                            v-for="(item,index) in periods"
                                    />
                                </vs-select>
                            </div>
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Rôles & Permissions"
                                        v-model="input.role"
                                        placeholder="Sélectionner un rôle"
                                        :danger="!!formErrors.role"
                                        :danger-text="formErrors.role ? formErrors.role[0] : ''"
                                        v-on:change="resetErrors('role')"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.display_name"
                                            v-for="(item,index) in roles"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-select
                                        class="w-full"
                                        autocomplete
                                        label="Type de connexion"
                                        v-model="input.firstly"
                                        placeholder="Sélectionner un type"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in typesConnexion"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
                <vs-row class="mb-2" v-if="input.role === 10">
                    <vs-col>
                        <div class="flex -mx-2">
                            <div class="w-1/2 px-2">
                                <vs-select
                                        autocomplete
                                        label="Sélectionner une région pour le superviseur"
                                        v-model="input.region"
                                        placeholder="Sélectionner une région"
                                        :danger="!!formErrors.region"
                                        :danger-text="formErrors.region ? formErrors.region[0] : ''"
                                        v-on:change="resetErrors('region')"
                                >
                                    <vs-select-item
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in regions"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-card>
        </div>
        <div class="vx-col w-full lg:w-1/3">
            <vx-card title="Enregister">
                <small>Activation/Désactivation</small>
                <ul class="centerx">
                    <li>
                        <vs-radio v-model="input.state" vs-name="state" :vs-value="1">Activé</vs-radio>
                    </li>
                    <li>
                        <vs-radio v-model="input.state" vs-name="state" :vs-value="0">Désactivé</vs-radio>
                    </li>
                </ul>
                <vs-divider style="height: 2px" background="primary"></vs-divider>
                <small>Canal de notification</small>
                <ul class="centerx">
                    <li>
                        <vs-checkbox v-model="input.channel_email">Email</vs-checkbox>
                    </li>
                    <li>
                        <vs-checkbox v-model="input.channel_sms">SMS</vs-checkbox>
                    </li>
                </ul>

                <br/>
                <vs-button color="primary" type="filled" @click="submitData()">Enregistrer</vs-button>

            </vx-card>
        </div>
    </div>
</template>

<script>
    var input_tempon = {
        deleted_at: "",
        id: "",
        slug: "",
        firstname: "", //
        lastname: "", //
        email: "", //
        phone: "",
        birthday: "",
        hired_at: "",
        others: "",
        fonction_id: "",
        media_id: "",
        email_notification: "",
        firstly: "",
        team_id: "",
        manager: 0,
        channel: 1,
        state: 0,
        email_verified_at: "",
        reset_password_token_end_at: "",
        created_at: "", //
        updated_at: "",
        role: "", //
        fonction: "", //------------
        media: "",
        team: "" //------------
    };
    import VuePerfectScrollbar from "vue-perfect-scrollbar";

    import Datepicker from "vuejs-datepicker";
    import * as lang from "vuejs-datepicker/src/locale";

    export default {
        name: "createUser",
        props: {
            base: ""
        },
        components: {
            VuePerfectScrollbar,
            Datepicker
        },
        watch: {},
        data() {
            return {
                periods: [],
                param44444: "",
                url: "/users",
                typesConnexion: [
                    {name: 'AD', id: 0},
                    {name: 'Franchise', id: 1}
                ],
                input: {
                    id: "",
                    slug: "",
                    firstname: "", //
                    lastname: "", //
                    email: "", //
                    phone: "",
                    birthday: "",
                    hired_at: "",
                    manager: 0,
                    channel_sms: false,
                    channel_email: true,
                    state: 0,
                    role: "", //
                    fonction: "", //------------
                    team: "",
                    firstly: 1
                },
                state: "",
                channel: "",
                roles: [],
                regions: [],
                functions: [],
                teams: [],
                language: "fr",
                languages: lang,
                settings: {
                    maxScrollbarLength: 600,
                    wheelSpeed: 0.6
                },
                formErrors: {}
            };
        },
        computed: {
            getApp() {
                return window.getApp;
            }
        },
        mounted(){
            for (let i = 1; i<101; i++){
                this.periods.push(i)
            }
        },
        methods: {
            downloadModelFile() {
                window.open(
                    this.$http.defaults.baseURL +
                    "export/users/downloadDeleteTemplate/?client=$2y$10$jNEnQLLrG7.7BJSAnUDhwelxLbVi2/4GJrz3YPRA3Fu2RPLCHVUWW&token=" +
                    localStorage.getItem("accessToken"),
                    "_blank"
                );
            },
            mountedFounction() {
                this.inputInitialize();
                this.getTeams();
                this.getFunctions();
                this.getRoles();
            },
            initInput() {
                this.input = JSON.parse(JSON.stringify(input_tempon));
            },
            inputInitialize() {
                this.base.item !== ""
                    ? ((this.input = JSON.parse(JSON.stringify(this.base.item))),
                        this.input.roles.length
                            ? (this.input.role = this.input.roles[0])
                            : (this.input.role = ""))
                    : this.initInput();


                this.input.channel = this.input.email_notification;

                this.input = JSON.parse(JSON.stringify(this.input));
            },
            getTeams() {
                this.$vs.loading();
                this.$http.get("/teams").then(response => {
                    this.teams = response.data;
                    this.$vs.loading.close();
                });
            },
            getFunctions() {
                this.$vs.loading();
                this.$http.get("/functions").then(response => {
                    this.functions = response.data.data;
                    this.$vs.loading.close();
                });
            },
            getRegions() {
                this.$vs.loading();
                this.$http.get("/regions").then(response => {
                    this.regions = response.data.data;
                    this.$vs.loading.close();
                });
            },
            getRoles() {
                this.$vs.loading();
                this.$http.get("/roles").then(response => {
                    this.roles = response.data.data;
                    this.$vs.loading.close();
                    /*if (this.base.item === "") {
                      for (var i = 0; i < this.roles.length; i++) {
                        if (this.roles[i].id === 3) {
                          this.input.role = JSON.parse(JSON.stringify(this.roles[i]));
                          break;
                        }
                      }
                    }*/
                });
            },
            submitData() {


                this.$vs.loading();

                this.$http
                    .post(this.url, this.input)
                    .then(response => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Succès",
                            text: "Utilisateur créé avec succès",
                            color: "success",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-check-circle"
                        });
                        this.$router.push({path: '/users/all'})
                    })
                    .catch(error => {
                        if (error.response.data.status_code === 422) {
                            this.$vs.loading.close();
                            this.$vs.notify({
                                title: "Erreur",
                                text: "Veuilliez valider les champs du formulaire",
                                color: "danger",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-alert-circle"
                            });
                            this.formErrors = error.response.data.errors;
                        }
                        if (error.response.data.status_code === 500) {
                            this.$vs.loading.close();
                            this.$vs.error({
                                title: "Erreur",
                                text: "Une erreur s'est produite sur le serveur",
                                color: "danger",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-alert-circle"
                            });
                        }
                    });
            },
            resetErrors(field) {
                if (field) {
                    this.formErrors[field] = null;
                } else {
                    this.formErrors = [];
                    Object.keys(this.input).forEach(index => (this.input[index] = null));
                }
            }
        },
        created() {
            //this.inputInitialize();
            this.getTeams();
            this.getFunctions();
            this.getRoles();
            this.getRegions();
        }
    };
</script>

<style></style>
